module.exports = __webpack_public_path__ + "img/GA_8_17.bfdd5f4e.png";